import axios from 'axios';
import { ladeToken, loescheAuth } from 'core/features/auth/authApi';

/**
 * Axios-Client fuer die Wissen-API (`/api/wissen`). nginx leitet `/api/*` an den
 * api-service weiter. Alle Endpunkte sind nutzerbezogen und per JWT geschuetzt;
 * uebertragen werden ausschliesslich verschluesselte Daten (Zero-Knowledge).
 */
const wissenApi = axios.create({
  baseURL: '/api/wissen',
  timeout: 30000,
});

wissenApi.interceptors.request.use((config) => {
  const token = ladeToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

wissenApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      loescheAuth();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    return Promise.reject(error);
  }
);

const data = (response) => response.data;

// ── Notizen ─────────────────────────────────────────────
export const fetchNotizenApi = () => wissenApi.get('/notizen').then(data);
export const createNotizApi = (notiz) => wissenApi.post('/notizen', notiz).then(data);
export const updateNotizApi = (uuid, notiz) => wissenApi.put(`/notizen/${uuid}`, notiz).then(data);
export const deleteNotizApi = (uuid) => wissenApi.delete(`/notizen/${uuid}`).then(() => uuid);

// ── Ordner ──────────────────────────────────────────────
export const fetchOrdnerApi = () => wissenApi.get('/ordner').then(data);
export const createOrdnerApi = (ordner) => wissenApi.post('/ordner', ordner).then(data);
export const updateOrdnerApi = (uuid, ordner) => wissenApi.put(`/ordner/${uuid}`, ordner).then(data);
export const deleteOrdnerApi = (uuid) => wissenApi.delete(`/ordner/${uuid}`).then(() => uuid);

// ── Dateien ─────────────────────────────────────────────
export const fetchDateienApi = () => wissenApi.get('/dateien').then(data);
export const downloadDateiApi = (uuid) => wissenApi.get(`/dateien/${uuid}`).then(data);
export const createDateiApi = (datei) => wissenApi.post('/dateien', datei).then(data);
export const deleteDateiApi = (uuid) => wissenApi.delete(`/dateien/${uuid}`).then(() => uuid);
export const verschiebeDateiApi = (uuid, ordnerId) =>
  wissenApi
    .put(`/dateien/${uuid}/ordner`, null, { params: ordnerId != null ? { ordnerId } : {} })
    .then(data);

export default wissenApi;
